import type { FormDefinition2 } from '@gov-nx/core/service';
import { useFormBuilderWithConsent } from '@gov-nx/core/service';

export interface MojeAutorizaceSouhlas {}

type Fields = Record<string, never>;

export type MojeAutorizaceSouhlasForm = FormDefinition2<
	MojeAutorizaceSouhlas,
	Fields
>;

type useAuthorizationFormProps = {
	isLoading?: boolean;
	isLowAuthorization: boolean;
};

export const useAuthorizationForm = ({
	isLoading = false,
	isLowAuthorization,
}: useAuthorizationFormProps) =>
	useFormBuilderWithConsent<MojeAutorizaceSouhlas, Fields>([], {
		isDisabled: isLoading,
		isLowAuthorization,
	});
